import React from 'react';
import { Box } from '~ui-kit/components/box/box';

interface DetailRowProps {
  children: React.ReactNode;
}

export function DetailRow({ children }: DetailRowProps) {
  return (
    <Box maxWidth={['100%', '100%', '500px']} alignItems="center">
      <Box flexDirection="column" width="100%">
        {children}
      </Box>
    </Box>
  );
}
